export default __webpack_public_path__ + "static/media/JourneyMapPortrait.56a0648c.png";